"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.platformSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {};
exports.platformSlice = (0, toolkit_1.createSlice)({
    name: 'platform',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = {
                status: 'done',
                error: undefined,
                data: action.payload,
            };
        },
        setLoading: (state) => {
            state.user = {
                status: 'loading',
                error: undefined,
                data: undefined,
            };
        },
        setError: (state, action) => {
            state.user = {
                status: 'error',
                error: action.payload,
                data: undefined,
            };
        },
        clearUser: (state) => {
            state.user = undefined;
        },
    },
});
